import { AgentConfiguration, Language } from '@big-red-group/storefront-common-checkout'

export const CANONICAL_BASE_URL = 'www.experienceoz.com.au'
export const DEFAULT_LANGUAGE: Language = 'en'

export const toName = (urlSegment: string) =>
  urlSegment
    .replaceAll('-', ' ')
    .split(' ')
    .map((token) => token.substring(0, 1).toUpperCase() + token.substring(1))
    .join(' ')

export const isLanguageValid = (lang: string) => {
  const validLangs: Language[] = [DEFAULT_LANGUAGE, 'zh']
  return validLangs.includes(lang as Language)
}

export const getPartnerCode = (host: string) => {
  if (host.includes('virgin')) {
    return 'virgin'
  }

  if (host.indexOf('localhost') !== -1 && host.split('.').length === 1) {
    return 'www'
  }

  return host.split('.')[0]
}

export const getAgentConfiguration = (host: string): AgentConfiguration => ({
  catalogueType: 'EXOZ',
  language: DEFAULT_LANGUAGE, // TODO language
  partnerCode: getPartnerCode(host),
})

export const removeProtocol = (url: string) => {
  return url.replace(/^(https?|http):\/\//, '')
}

// Gets an agent asset prefix for custom domains
export const getUrlPrefix = (handlerKey: string | undefined, trailingSlash?: boolean) => {
  // No asset prefix unless in prod
  if (process.env.NODE_ENV !== 'production') return ''
  switch (handlerKey) {
    case 'virgin':
      if (trailingSlash) {
        return '/au/en/experiences/'
      }
      return '/au/en/experiences'
    default:
      return ''
  }
}

// Checks if the req url has exoz or is localhost
export const isExozDomain = (host: string) => {
  if (host.includes('localhost') || host.includes('experienceoz')) {
    return true
  }
  return false
}

export const createCanonicalLink = (path: string): string => {
  return `https://${CANONICAL_BASE_URL}/${DEFAULT_LANGUAGE}/${path}`
}
